<template>
  <f7-list-item v-if="showOrder" swipeout :style="{ color: orderTextColor, 'background-color': orderBackgroundColor }">
    <f7-swipeout-actions right>
      <f7-swipeout-button
        close
        color="gray"
        @click="$f7router.navigate(`/stores/${store.id}/order-details/${order.publicId}?t=details`)">
        明細
      </f7-swipeout-button>
      <f7-swipeout-button
        v-if="(filterConfig.id === 'unpaid' || filterConfig.id === 'preOrder') && !order.paidAt"
        close
        :overswipe="(filterConfig.id === 'kitchen' || filterConfig.id === 'preOrder') && !order.doneAt ? false : true"
        color="green"
        @click="$f7router.navigate(`/stores/${store.id}/order-details/${order.publicId}?t=pay`)">
        結帳
      </f7-swipeout-button>
      <f7-swipeout-button
        v-if="(filterConfig.id === 'kitchen' || filterConfig.id === 'preOrder') && !order.doneAt"
        close
        overswipe
        color="blue"
        @click="doneButtonOnClick">
        <template v-if="useMonitor">呼叫</template>
        <template v-else>完成</template>
      </f7-swipeout-button>
      <f7-swipeout-button
        v-if="!order.deliveredAt && order.doneAt && order.paidAt"
        close
        overswipe
        color="red"
        @click="updateOrderOnClick({ deliveredAt: moment().toISOString() })">
        完成
      </f7-swipeout-button>
    </f7-swipeout-actions>
    <f7-swipeout-actions left>
      <f7-swipeout-button v-if="!order.paidAt" close color="black" @click="deleteOrderOnClick()">刪除</f7-swipeout-button>
    </f7-swipeout-actions>
    <div slot="inner" style="width: 100%;" :style="{ 'font-size': fontSize + 'px', 'line-height': fontSize + margin + 'px'}">
      <div style="font-weight: bold;" :style="{ 'font-size': fontSize * 1.25 + 'px', margin: `${margin}px 5px ${margin + 3}px 0px` }">
        <template v-if="!order.paidAt">*</template>
        <span>
          <span
            v-if="!order.useReceipt && (order.taxId || order.invoiceTitle)"
            style="position: absolute; left: 5px; top: 2px; border: solid 1px red; border-radius: 50%; color: red; font-size: 16px; line-height: 16px;">
            收
          </span>
          <span style="margin: 0px 5px 0px 0px;">{{ order.nickname }}</span>
          <span style="position: relative; top: 0px;">/</span>
          <span style="margin: 0px 5px;">
            ${{ parseFloat(order.totalPrice) }}
            <template v-if="order.refundedAt">(已退款)</template>
          </span>
          <span v-if="menus[order.menuVariation]" style="margin: 0px 5px;" :style="{ 'font-size': fontSize + 'px' }">
            {{ order.menuVariation === 'main' ? '' : menus[order.menuVariation].title }}
          </span>
          <span>
            <img v-if="order.paymentMethod === paymentMethodType.easyCard" src="@/assets/easyCard.png" :style="afterImageStyle" />
            <img v-else-if="order.paymentMethod === paymentMethodType.creditCard" src="@/assets/creditCard.png" :style="afterImageStyle" />
            <img v-else-if="order.paymentMethod === paymentMethodType.linePayOnline" src="@/assets/linePay.png" :style="afterImageStyle" />
            <img v-else-if="order.paymentMethod === paymentMethodType.chinaUnionPay" src="@/assets/chinaUnionPay.png" :style="afterImageStyle" />
            <img v-else-if="order.paymentMethod === paymentMethodType.jkos" src="@/assets/jkos.png" :style="afterImageStyle" />
            <img v-else-if="order.paymentMethod === paymentMethodType.cash" src="@/assets/cash.png" :style="afterImageStyle" />
          </span>
        </span>
        <span style="float: right; text-align: right;">
          <order-list-item-after :order="order" />
          <div style="margin: 10px 2px 0px 5px; color: #888888; font-weight: normal;" :style="{ 'font-size': fontSize + 'px'}">
            {{ moment.tz(order.updatedAt, 'utc').tz('Asia/Taipei').format('HH:mm') }}
          </div>
        </span>
      </div>
      <order-list-item-main
        v-for="(itemObj, index) in order.data.items"
        :key="`order-list-${index}`"
        :orderId="parseInt(order.id)"
        :itemObj="itemObj"
        @done="v => setItemDone({ orderId: order.id, index, done: v, channel: 'main' })"
        :specialRequests="itemObj.specialRequests"
        :menu="menus[order.menuVariation] ? menus[order.menuVariation][order.menuVersion] : null"
        :menuVersion="order.menuVersion"
        :menuVariation="order.menuVariation"
        :filterConfig="filterConfig" />
    </div>
  </f7-list-item>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import OrderListItemMain from '../components/OrderListItemMain'
import OrderListItemAfter from '../components/OrderListItemAfter'
import moment from 'moment-timezone'
import * as R from 'ramda'

export default {
  name: 'order-list-item',
  dependencies: [
    'platformUtils',
    'diningPreferenceType',
    'paymentMethodType'
  ],
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['store', 'currentMinute', 'useMonitor', 'settings']),
    ...mapState('menuModule', ['menus']),
    ...mapGetters(['useMonitor']),
    moment () { return moment },
    compactItems () {
      return this.order.data.items.reduce((cis, i) => {
        const index = cis.findIndex(ci => R.equals(ci.itemObj, i))
        if (index > -1) {
          cis[index].amount++
        } else {
          cis.push({ itemObj: i, amount: 1 })
        }
        return cis
      }, [])
    },
    orderTextColor () {
      if (this.order.diningPreference === this.diningPreferenceType.forHere) {
        return '#000000'
      } else if (this.order.diningPreference === this.diningPreferenceType.preOrder) {
        return '#0080A9'
      } else {
        return '#134290'
      }
    },
    showOrder () {
      // TODO: 這個之後要放到 filterConfigs 裡面
      if (
        this.filterConfig.id === 'kitchen' &&
        this.order.diningPreference === this.diningPreferenceType.preOrder &&
        // 這樣做是為了讓這個 function 可以自動更新
        (!moment(this.currentMinute).clone().add(this.store.preOrderDisplayBoundaryMinutes, 'm').isAfter(this.order.pickupTime) ||
          (this.store.shouldPreOrderPrePaid && !this.order.paidAt))
      ) {
        return false
      }
      return true
    },
    orderBackgroundColor () {
      if (moment(this.currentMinute).clone().add(this.store.preOrderDisplayBoundaryMinutes, 'm').isAfter(this.order.pickupTime)) {
        return '#F8D7DA'
      }
      return '#FFFFFF'
    },
    afterImageStyle () {
      return { 'height': `${this.settings.fontSize * 7 / 8 - 2}px` }
    }
  },
  props: {
    fontSize: {
      default: 16,
      type: Number
    },
    margin: {
      default: 5,
      type: Number
    },
    filterConfig: Object,
    order: Object
  },
  methods: {
    ...mapActions('orderModule', ['setItemDone', 'deleteOrder', 'updateOrder']),
    doneButtonOnClick () {
      if (this.useMonitor || this.order.diningPreference === this.diningPreferenceType.preOrder) {
        this.updateOrderOnClick({ doneAt: moment().toISOString() })
      } else {
        this.updateOrderOnClick({ deliveredAt: moment().toISOString() })
      }
    },
    updateOrderOnClick (data) {
      const orderSnapshot = Object.assign({}, this.order)
      const newOrder = Object.assign({}, this.order, data)
      Object.keys(newOrder).forEach(k => {
        if (orderSnapshot[k] === undefined) { // 不能用 !orderSnapshot[k] 因為原本是 null 也有可能過
          orderSnapshot[k] = null
        }
      })

      this.updateOrder({ order: newOrder })
      const that = this
      this.$f7.toast.create({
        text: '訂單: ' + orderSnapshot.nickname + ' 已更新',
        closeButton: true,
        closeButtonText: '復原',
        closeButtonColor: 'yellow',
        closeTimeout: 5000,
        on: {
          closeButtonClick () {
            that.updateOrder({ order: orderSnapshot })
          }
        }
      }).open()
    },
    deleteOrderOnClick () {
      const orderSnapshot = Object.assign({}, this.order)
      this.deleteOrder(Object.assign({}, this.order))
      const that = this
      this.$f7.toast.create({
        text: '訂單: ' + orderSnapshot.nickname + ' 已刪除',
        closeButton: true,
        closeButtonText: '復原',
        closeButtonColor: 'yellow',
        closeTimeout: 5000,
        on: {
          closeButtonClick () {
            that.updateOrder({ order: orderSnapshot })
          }
        }
      }).open()
    }
  },
  components: {
    OrderListItemMain,
    OrderListItemAfter
  }
}
</script>
